import locale from "./locales/en";
import { blockScreen } from "./common";
import { IAlertProps } from "./types";

export function alert(props: IAlertProps) {
	const apply = props.buttons && props.buttons[0] ? props.buttons[0] : locale.apply;

	const unblock = blockScreen(props.blockerCss);

	return new Promise(res => {

		const alertBox = document.createElement("div");
		alertBox.className = "dhx_widget dhx_alert " + (props.css || "");

		alertBox.innerHTML = `
			${props.header ? `<div class="dhx_alert__header"> ${props.header} </div>` : ""}
			${props.text ? `<div class="dhx_alert__content">${props.text}</div>` : ``}
			<div class="dhx_alert__footer ${props.buttonsAlignment ? ("dhx_alert__footer--" + props.buttonsAlignment) : ""}">
				<button class="dhx_alert__apply-button dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium">${apply}</button>
			</div>`;
		document.body.appendChild(alertBox);
		(alertBox.querySelector(".dhx_alert__apply-button") as HTMLElement).focus();

		alertBox.querySelector("button").addEventListener("click", () => {
			unblock();
			document.body.removeChild(alertBox);
			res(true);
		});
	});
}